import React, { useState } from "react"
import Box from "@mui/material/Box"
import Paper from "@mui/material/Paper"
import InputBase from "@mui/material/InputBase"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import SearchIcon from "@mui/icons-material/Search"

const SearchHome = ({
  defaultLabel,
  setSearch,
  onSearch,
  search,
  setKeyword,
  keyword,
  data,
  style = {}
}) => {
  const [label, setLabel] = useState("")
  const menuProps = {
    PaperProps: {
      elevation: 0,
      sx: {
        mt: 1,
        borderRadius: "10px",
        border: "1px solid #E5E7EB",
        boxShadow: "0 12px 28px rgba(15, 23, 42, 0.12)",
        overflow: "hidden",
        "& .MuiList-root": { py: 0.75 },
        "& .MuiMenuItem-root": {
          mx: 0.75,
          my: 0.25,
          px: 1.5,
          py: 1.1,
          borderRadius: "8px",
          color: "#2F3744",
          fontSize: "0.95rem",
          transition: "background-color 160ms ease, transform 160ms ease",
          "&:hover": {
            backgroundColor: "#F1F4F8",
            transform: "translateX(2px)"
          },
          "&.Mui-selected": {
            backgroundColor: "#EEF5FF",
            color: "#1976D2",
            fontWeight: 700
          }
        }
      }
    }
  }

  return (
    <Box style={{ display: "flex", gap: "10px", width: "100%", minHeight: "46px" }}>
      <Box style={{ display: "flex", position: "relative", width: "100%" }}>
        <Paper
          sx={{
            border: "1px solid #D8DDE6",
            borderRadius: "12px",
            boxShadow: "none",
            display: "flex",
            overflow: "hidden",
            alignItems: "center",
            minHeight: "46px",
            width: style.width || "100%",
            "&:focus-within": {
              borderColor: "#1976D2",
              boxShadow: "0 0 0 3px rgba(25, 118, 210, 0.12)"
            }
          }}
        >
          <Select
            id="demo-simple-select"
            value={keyword}
            onChange={(event, value) => {
              // console.log(event.target.value, value.props);
              setLabel(value.props.children)
              setKeyword(event.target.value)
            }}
            displayEmpty
            MenuProps={menuProps}
            inputProps={{ "aria-label": "Without label" }}
            sx={{
              backgroundColor: "#fff",
              borderRight: "1px solid #E5E7EB",
              color: "#111827",
              fontSize: "0.92rem",
              fontWeight: 700,
              height: "46px",
              minWidth: 124,
              "& fieldset": { border: "none" }
            }}
          >
            {data.map((item, index) => (
              <MenuItem key={index} value={item.route}>
                {item.name}
              </MenuItem>
            ))}
          </Select>

          <InputBase
            sx={{
              color: "#111827",
              flex: 1,
              fontSize: "0.95rem",
              height: "100%",
              lineHeight: "46px",
              px: 1.5,
              "& input::placeholder": { color: "#8A94A6", opacity: 1 }
            }}
            placeholder={`Search by ${label || defaultLabel || data[0].name}`}
            onChange={({ currentTarget: input }) => setSearch(input.value)}
            value={search}
          />
          {/* <SearchIcon
        sx={{ position: 'absolute', right: 5, cursor: 'pointer' }}
        onClick={onSearch}
      /> */}
        </Paper>
      </Box>
    </Box>
  )
}

export default SearchHome
